import { Col, Container, Row } from 'react-bootstrap'
import styled from 'styled-components'
export const SummarySection = styled(Row)`
    padding-top: .5rem;
    display: flex;
    align-items: center;
  
`